import React, { useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ArrowDownIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';
import { SwitcherIcon } from 'app/components/shared/icons';
import { AnimatePresence } from 'framer-motion';
import useOnClickOutside from 'hooks/click-outside';
import useUserData from 'hooks/useUserData';
import {
  contextSelector,
  IPeopleContext,
  PEOPLE_CONTEXT,
} from 'store/reducers/people/people-reducer';
import { ThemeProvider } from 'styled-components';

import usePeopleResetSearch from '../usePeopleResetSearch';
import {
  PeopleMobileSwitcherBetaContainer,
  PeopleMobileSwitcherBetaLabel,
  PeopleMobileSwitcherContainer,
  PeopleMobileSwitcherOptionContainer,
  PeopleMobileSwitcherTitle,
  PeopleMobileSwitcherWrapper,
} from './styled';

export default function PeopleMobileSwitcher() {
  const userData = useUserData();
  const context = useSelector(contextSelector);
  const { push } = useHistory();
  const resetSearch = usePeopleResetSearch();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(wrapperRef, (e) => {
    const container = document.querySelector('[data-id="people-mobile-switcher-container"]');

    if (container && !container.contains(e.target as Node)) {
      setIsOpen(false);
    }
  });

  const handleSwitcherClick = () => {
    resetSearch();
    if (context === PEOPLE_CONTEXT.TEAMING) {
      push('/people');
    } else {
      push('/teaming');
    }
  };

  if (!userData.permissions?.teaming_access) {
    return (
      <PeopleMobileSwitcherWrapper>
        <PeopleMobileSwitcherTitle>Collective Directory</PeopleMobileSwitcherTitle>
      </PeopleMobileSwitcherWrapper>
    );
  }

  return (
    <ThemeProvider theme={{ isOpen, context }}>
      <PeopleMobileSwitcherWrapper onClick={handleSwitcherClick} ref={wrapperRef}>
        <PeopleMobileSwitcherOptionContainer
          active={context === PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY}
        >
          <PeopleMobileSwitcherTitle>Collective Directory</PeopleMobileSwitcherTitle>
        </PeopleMobileSwitcherOptionContainer>
        <SwitcherIcon fill="rgba(23, 28, 51, 0.5)" width={20} height={20} />
        <PeopleMobileSwitcherOptionContainer active={context === PEOPLE_CONTEXT.TEAMING}>
          <PeopleMobileSwitcherTitle>Teaming</PeopleMobileSwitcherTitle>
          <PeopleMobileSwitcherBetaContainer>
            <PeopleMobileSwitcherBetaLabel>BETA</PeopleMobileSwitcherBetaLabel>
          </PeopleMobileSwitcherBetaContainer>
        </PeopleMobileSwitcherOptionContainer>
      </PeopleMobileSwitcherWrapper>
    </ThemeProvider>
  );
}
